const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelebrationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "110px",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    viewBox: "0 0 110 110",
    width: "110px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Multicolor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.138,83.047c0.207-0.462,12.791-28.593,15.514-34.68c-0.702,3.651,3.525,10.256,8.125,14.857      c5.591,5.591,11.866,8.87,15.116,8.034c-5.634,2.522-34.503,15.411-34.939,15.605c-0.798,0.367-2.002-0.017-2.896-0.92      C23.155,85.049,22.771,83.845,23.138,83.047z",
    style: {
      fill: "#F0F1F1"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.138,83.047c0.207-0.462,12.791-28.593,15.514-34.68c-0.701,3.648,3.517,10.244,8.112,14.844     L24.045,85.928C23.152,85.037,22.773,83.841,23.138,83.047z",
    style: {
      fill: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 37,
    r: 2,
    style: {
      fill: "#DF2C2C"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 41,
    r: 2,
    style: {
      fill: "#F37A10"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 49,
    r: 2,
    style: {
      fill: "#059BBF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 71,
    r: 2,
    style: {
      fill: "#FA5655"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 27,
    r: 2,
    style: {
      fill: "#12B2A0"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "72.877,26.652 68.925,28.666 65.788,25.529 66.482,29.911 62.529,31.925 66.911,32.619       67.605,37 69.619,33.047 74,33.741 70.863,30.605     ",
    style: {
      fill: "#FA5655"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "72.035,60 71.082,62.932 68,62.932 70.494,64.588 69.541,67.442 72.035,65.591       74.529,67.383 73.576,64.598 76.07,62.932 72.988,62.932     ",
    style: {
      fill: "#F37A10"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65,50c9.961,0,12.055-6.333,13.737-11.421C80.138,34.345,81.244,31,86,31c0.552,0,1-0.448,1-1      s-0.448-1-1-1c-6.201,0-7.706,4.551-9.161,8.951C75.13,43.119,73.516,48,65,48c-0.552,0-1,0.448-1,1S64.448,50,65,50z",
    style: {
      fill: "#DF2C2C"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.625,43.781c7.008-5.607,4.519-9.36,2.112-12.991C52.391,28.761,51,26.663,51,24      c0-0.552-0.448-1-1-1s-1,0.448-1,1c0,3.266,1.631,5.725,3.07,7.896c2.34,3.528,3.886,5.86-1.695,10.324      c-0.431,0.345-0.501,0.974-0.156,1.406C50.567,44.059,51.196,44.124,51.625,43.781z",
    style: {
      fill: "#059BBF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86,62c0.552,0,1-0.448,1-1s-0.448-1-1-1c-2.858,0-5.139-1.521-7.345-2.992      c-3.562-2.375-7.246-4.832-12.362,0.285c-0.391,0.39-0.391,1.024,0,1.414c0.39,0.391,1.024,0.391,1.414,0      c3.957-3.956,6.296-2.396,9.838-0.035C79.885,60.232,82.536,62,86,62z",
    style: {
      fill: "#12B2A0"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.221,81.352c-9.117,4.109,1.86-0.816-7.266,3.274c-2.222-2.305-4.326-4.776-6.222-7.38      c1.062-2.374,2.356-5.268,3.716-8.307C32.074,73.57,35.412,77.783,39.221,81.352z",
    style: {
      fill: "#DF2C2C"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.133,75.84l-5.316,5.317c-1.075-1.266-2.108-2.57-3.084-3.912     c1.062-2.374,2.356-5.268,3.716-8.307C30.825,71.366,32.401,73.675,34.133,75.84z",
    style: {
      fill: "#FA5655"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.777,63.223c6.48,6.479,13.889,9.868,16.428,7.325c2.519-2.519-0.767-9.871-7.327-16.44     c-6.569-6.56-13.919-9.835-16.439-7.327C36.506,49.711,41.398,57.844,46.777,63.223z",
    style: {
      fill: "#E2E4E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.322,66.558c-3.574-4.837-5.737-9.946-6.194-14.51c-0.487-1.39-0.674-2.649-0.477-3.679    l-5.611,12.563c1.406,3.037,3.227,6.089,5.41,9.045c2.272,3.074,4.83,5.892,7.555,8.375l7.602-3.396    C50.593,72.705,47.736,69.839,45.322,66.558z",
    style: {
      fill: "#DF2C2C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.871,54.102l-9.107,9.107c-5.374-5.379-10.255-13.501-7.326-16.428     C41.958,44.275,49.304,47.547,55.871,54.102z",
    style: {
      fill: "#F0F1F1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.651,48.369l-5.611,12.563c1.406,3.037,3.227,6.089,5.41,9.045    c0.219,0.296,0.453,0.578,0.677,0.87l5.413-5.413c-3.102-4.503-4.994-9.18-5.416-13.395C38.64,50.652,38.454,49.396,38.651,48.369    z",
    style: {
      fill: "#FA5655"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationIcon);
export default __webpack_public_path__ + "static/media/celebration-icon.0d9bb9633fcda75b7632a11eaf12bbac.svg";
export { ForwardRef as ReactComponent };